import { useState } from 'react';

// Custom hook untuk toggle animation dengan state management
export const useToggleAnimation = (initialState = false, animationDuration = 300) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [isAnimating, setIsAnimating] = useState(false);

  const toggle = () => {
    if (isAnimating) return; // Prevent rapid clicks during animation
    
    setIsAnimating(true);
    setIsOpen(!isOpen);
    
    // Reset animation state after animation completes
    setTimeout(() => {
      setIsAnimating(false);
    }, animationDuration);
  };

  const open = () => {
    if (isAnimating || isOpen) return;
    
    setIsAnimating(true);
    setIsOpen(true);
    
    setTimeout(() => {
      setIsAnimating(false);
    }, animationDuration);
  };

  const close = () => {
    if (isAnimating || !isOpen) return;
    
    setIsAnimating(true);
    setIsOpen(false);
    
    setTimeout(() => {
      setIsAnimating(false);
    }, animationDuration);
  };

  // Auto-close functionality
  const autoClose = (delay = 5000) => {
    if (isOpen) {
      setTimeout(() => {
        close();
      }, delay);
    }
  };

  return {
    isOpen,
    isAnimating,
    toggle,
    open,
    close,
    autoClose
  };
};

// Animation states untuk CSS classes
export const getAnimationClasses = (isOpen, isAnimating, baseClass = '') => {
  const classes = [baseClass];
  
  if (isOpen) {
    classes.push(`${baseClass}--open`);
  }
  
  if (isAnimating) {
    classes.push(`${baseClass}--animating`);
  }
  
  return classes.join(' ');
};

// Animation styles untuk inline styles
export const getAnimationStyles = (isOpen, isAnimating) => {
  return {
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0)' : 'translateY(-20px)',
    transition: isAnimating ? `all 0.3s cubic-bezier(0.4, 0, 0.2, 1)` : 'none',
    pointerEvents: isOpen ? 'auto' : 'none',
    visibility: isOpen ? 'visible' : 'hidden'
  };
};
